import { createPopper } from '../../js/vendors/popper.min';
var tooltip = null;
var popperInstance = null;

function hideTooltip(e) {
  if (tooltip) {
    tooltip.removeAttribute('data-show');
    tooltip = null;
  }

  if (popperInstance) {
    popperInstance.destroy();
    popperInstance = null;
  }
}

function showTooltip(e) {
  if (!e.target.classList.contains('js-tooltip')) return;
  var el = e.target;
  var id = el.getAttribute('data-tooltip') || '';
  id = id.indexOf('#') === 0 ? id.substr(1) : id;
  if (!id.length) return;
  tooltip = document.getElementById(id);
  if (!tooltip) return;
  tooltip.setAttribute('data-show', '');
  popperInstance = createPopper(el, tooltip, {
    tetherOffset: 10,
    placement: 'bottom-end',
    strategy: 'fixed',
    modifiers: [{
      name: 'offset',
      options: {
        offset: [0, 5]
      }
    }, {
      name: 'preventOverflow',
      options: {
        altAxis: true,
        padding: 20
      }
    }]
  });
  el.addEventListener('mouseleave', hideTooltip, {
    once: true
  });
  el.addEventListener('touchend', hideTooltip, {
    once: true
  });
}

document.body.addEventListener('mouseenter', showTooltip, true);
document.body.addEventListener('touchstart', showTooltip, true);